import React from "react";
import { Link } from "react-router-dom";
import Button from '../../button/Button';
import dispatchEvent from '../../../fns/common/dispatchEvent';

import gen from '../../../assets/images/gen-banner.gif';
import owners from '../../../assets/images/owners-banner.gif';
import epack from '../../../assets/images/epack-banner.gif';
import metapack from '../../../assets/images/metapack-banner.gif';

const Collections = () => {
    return (
        <section className="the-collections">
            <div className="container mx-auto">
                <h1 className="lt-white font-bold text-center mb-5 mt-5">The Collections</h1>
                <div className="collections-list">
                    <div className="single-collection" id="genesis">
                        <div>
                            <img src={gen} alt="genesis metafan"></img>
                        </div>
                        <div className="mt-5 mb-5">
                            <h2 className="lt-white font-bold">Genesis Metafans Collection</h2>
                            <p className="text-grey">Each NFT is unique. Own a complete set, The Jock, The Cheerleader, The Die Hard, and the Average Joe, and get enhanced member benefits!</p>
                        </div>
                        <div className="flex flex-col md:flex-row items-start justify-center collection-stats font-bold">
                            <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                                <div>
                                    <p className="text-grey">Collection</p>
                                    <h2 className="lt-white">10k</h2>
                                </div>
                            </div>
                            <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                                <div>
                                    <p className="text-grey">Traits</p>
                                    <h2 className="lt-white">700+ hand-drawn</h2>
                                </div>
                            </div>
                            <div className="flex items-center w-full md:w-1/3 justify-start md:justify-center items-center stat-item">
                                <div>
                                    <p className="text-grey">Avatars</p>
                                    <h2 className="lt-white">4</h2>
                                </div>
                            </div>
                        </div>
                        <div className="mint">
                            <Button
                                variant="Primary"
                                className=""
                                onClick={() => dispatchEvent("opensaleModalRequested")}
                            >
                                Mint a MetaFan NFT
                            </Button>
                        </div>
                    </div>
                    <div className="single-collection" id="obg">
                        <img src={owners} alt="Owners’ Box Guest"></img>
                        <div className="mt-5 mb-5">
                            <h2 className="lt-white font-bold">Owners’ Box Guest</h2>
                            <p className="text-grey">Included in the Genesis collection, these are the rarest and most valuable. If minted, the lucky holder gets exponentially greater odds of winning our community contests and giveaways!</p>
                        </div>
                        <div className="flex flex-col md:flex-row items-start justify-center collection-stats font-bold">
                            <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                                <div>
                                    <p className="text-grey">Collection</p>
                                    <h2 className="lt-white">18 in 10k</h2>
                                </div>
                            </div>
                            <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                                <div>
                                    <p className="text-grey">Traits</p>
                                    <h2 className="lt-white">unique one-of-one</h2>
                                </div>
                            </div>
                            <div className="flex items-center w-full md:w-1/3 justify-start md:justify-center items-center stat-item"></div>
                        </div>
                        <div className="mint">
                            <Button
                                variant="Primary"
                                className=""
                                onClick={() => dispatchEvent("opensaleModalRequested")}
                            >
                                Mint a MetaFan NFT
                            </Button>
                        </div>
                    </div>
                    <div className="single-collection" id="fanepack">
                        <img src={epack} alt="FanEpacks"></img>
                        <div className="mt-5 mb-5">
                            <h2 className="lt-white font-bold">FanEpacks</h2>
                            <p className="text-grey">Free with each MetaFans NFT mint (*minus gas fees), this collection enhances member benefits and gives you access to FanEpack-only exclusives.  The more FanEpacks you hold, the greater the rewards!</p>
                        </div>
                        <div className="flex flex-col md:flex-row items-start justify-center collection-stats font-bold">
                            <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                                <div>
                                    <p className="text-grey">Collection</p>
                                    <h2 className="lt-white">10k</h2>
                                </div>
                            </div>
                            <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                                <div>
                                    <p className="text-grey">Traits</p>
                                    <h2 className="lt-white">400+ hand-drawn</h2>
                                </div>
                            </div>
                            <div className="flex items-center w-full md:w-1/3 justify-start md:justify-center items-center stat-item"></div>
                        </div>
                        <div className="mint">
                            <Button
                                variant="Primary"
                                className=""
                                onClick={() => dispatchEvent("fanEpackModalRequested")}
                            >
                                Claim Your FanEpack
                            </Button>
                        </div>
                    </div>
                    <div className="single-collection" id="metapacks">
                        <img src={metapack} alt="MetaPacks"></img>
                        <div className="mt-5 mb-5">
                            <h2 className="lt-white font-bold">MetaPacks</h2>
                            <p className="text-grey">These are a limited series of super-rare FanEpacks. The lucky person who mints these will automatically get prize enhancement equivalent to owning 11 or more FanEpacks</p>
                        </div>
                        <div className="flex flex-col md:flex-row items-start justify-center collection-stats font-bold">
                            <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                                <div>
                                    <p className="text-grey">Collection</p>
                                    <h2 className="lt-white">22</h2>
                                </div>
                            </div>
                            <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                                <div>
                                    <p className="text-grey">Traits</p>
                                    <h2 className="lt-white">unique one-of-one</h2>
                                </div>
                            </div>
                            <div className="flex items-center w-full md:w-1/3 justify-start md:justify-center items-center stat-item"></div>
                        </div>
                        <div className="mint">
                            <Button
                                variant="Primary"
                                className=""
                                onClick={() => dispatchEvent("opensaleModalRequested")}
                            >
                                Mint a MetaFan NFT
                            </Button>
                        </div>
                    </div>


                    {/* <div className="single-collection">
                        <img src={metapack} alt="MetaPacks"></img>
                        <div className="mt-5 mb-5">
                            <h2 className="lt-white font-bold">Eliminator Cards</h2>
                            <p className="text-grey">These cards provide holders with exclusive access to play in our sports Eliminator Pools and win cash prizes.</p>
                        </div>
                        <div className="flex flex-col md:flex-row items-start justify-center collection-stats font-bold">
                            <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                                <div>
                                    <p className="text-grey">Collection</p>
                                    <h2 className="lt-white">22</h2>
                                </div>
                            </div>
                            <div className="mb-5 md:mb-0 flex items-center w-full md:w-1/3 justify-start items-center stat-item">
                                <div>
                                    <p className="text-grey">Traits</p>
                                    <h2 className="lt-white">unique one-of-one</h2>
                                </div>
                            </div>
                            <div className="flex items-center w-full md:w-1/3 justify-start md:justify-center items-center stat-item"></div>
                        </div>
                        <div className="mint">
                            <Button
                                variant="Primary"
                                className=""
                                onClick={() => dispatchEvent("opensaleModalRequested")}
                            >
                                Mint a MetaFan NFT
                            </Button>
                        </div>
                    </div> */}
                </div>
            </div>
        </section>
    );
};

export default Collections;